import { TelSysTypes } from '../../../NonReact/constants/TelephonyServerTypes'

export type CxiEntitlementVisibility = {
    showCxiUser: boolean
    showCxiData: boolean
    isApiOnlyMode: boolean
}

const INTEGRATED_CXI_TELSYS_TYPES: TelSysTypes[] = [
    TelSysTypes.MS_TEAMS,
    TelSysTypes.WEBEX_CALLING,
    TelSysTypes.BROADSOFT_BROADWORKS
]

/**
 * Resolve which CXI entitlement controls should be available for a TelSys.
 *
 * @param telSysType - Selected Telephony Server type.
 * @param isIntegratedCxiEnabled - Whether the selected integrated TelSys currently has CXI capability and feature support.
 *
 * @returns Visibility flags for CXI User / CXI Data controls.
 */
export const getCxiEntitlementVisibility = (
    telSysType: Nullable<TelSysTypes>,
    isIntegratedCxiEnabled: boolean
): CxiEntitlementVisibility => {
    if (telSysType === TelSysTypes.CXI_API) {
        return {
            showCxiUser: false,
            showCxiData: true,
            isApiOnlyMode: true
        }
    }

    if (telSysType && INTEGRATED_CXI_TELSYS_TYPES.includes(telSysType) && isIntegratedCxiEnabled) {
        return {
            showCxiUser: true,
            showCxiData: true,
            isApiOnlyMode: false
        }
    }

    return {
        showCxiUser: false,
        showCxiData: false,
        isApiOnlyMode: false
    }
}
